import {IbeConfig, PropertyConfig, SearchParams} from '../schema'
import currency from 'currency.js'
import {booking} from '@whyhotel/common-schema'

/**
 * Finds the property config for the property ID
 * @param propertyConfigs
 * @param propertyId
 * @returns
 */
export function findPropertyConfig(
  propertyConfigs: PropertyConfig[],
  propertyId: string
): PropertyConfig | undefined {
  return propertyConfigs.find(
    property => property.propertyApaleoId === propertyId
  )
}

/**
 * Checks if it's a region search
 * @param config
 * @param id
 * @returns
 */
export function isRegionSearch(config: IbeConfig, id: string): boolean {
  return config?.regions?.includes(id)
}

/**
 * Gets a list of property configs for a region
 * @param propertyConfigs
 * @param regionId
 * @returns
 */
export function getPropertyConfigsForRegion(
  propertyConfigs: PropertyConfig[],
  regionId: string
): PropertyConfig[] {
  return propertyConfigs.filter(property =>
    property?.regions?.includes(regionId)
  )
}

/**
 * Gets a list of property configs for a location
 * @param propertyConfigs
 * @param locationId
 * @returns
 */
export function getPropertyConfigsForLocation(
  propertyConfigs: PropertyConfig[],
  locationId: string
): PropertyConfig[] {
  return locationId === 'ALL'
    ? propertyConfigs
    : propertyConfigs.filter(property => property.location === locationId)
}

/**
 * Generates a UUID
 * @returns
 */
export function generateUUID(): string {
  const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
  return template.replace(/[xy]/g, c => {
    var r = (Math.random() * 16) | 0
    var v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * Formats a currency amount
 * @param value
 * @returns
 */
export function formatCurrency(value: any): string {
  return currency(value, {separator: ',', symbol: '$'}).format()
}

/**
 * Checks if any special rates are enabled in the search parameters
 * @param searchParams The search parameters
 * @returns boolean
 */
export function hasSpecialRates({specialRates}: SearchParams): boolean {
  return (
    (specialRates?.promoCode && specialRates?.promoCode?.length > 0) ||
    (specialRates?.corporateCode && specialRates?.corporateCode?.length > 0) ||
    specialRates?.hasAAA ||
    specialRates?.hasAARP ||
    specialRates?.hasGov ||
    specialRates?.hasMilitary
  )
}

/**
 * Gets the promo code from the special rates parameters
 * @param specialRates The special rates parameters
 * @returns
 */
export function getPromoCode(
  specialRates: booking.SearchSpecialRatesParams
): string | null {
  if (specialRates.promoCode && specialRates.promoCode.length > 0) {
    return specialRates.promoCode
  } else if (specialRates.hasAAA) {
    return 'AAA'
  } else if (specialRates.hasAARP) {
    return 'AARP'
  } else if (specialRates.hasGov) {
    return 'GOV'
  } else if (specialRates.hasMilitary) {
    return 'MIL'
  }
  return null
}
